// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"27a99542","498":"8e4b63fa","703":"ca92dbcb"}[chunkId] + ".chunk.js";
};